import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  convertToPixelCrop,
} from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import styles from './styles';

const ASPECT = 16 / 9;
const MIN_DIMENSION = 60;

function buildInitialCrop(width, height) {
  return centerCrop(
    makeAspectCrop({ unit: '%', width: 100 }, ASPECT, width, height),
    width,
    height
  );
}

@injectIntl
@withStyles(styles)
export default class Cropper extends Component {
  state = {
    crop: undefined,
    pixelCrop: undefined,
  };

  imgRef = React.createRef();

  onImageLoad = e => {
    const { naturalWidth, naturalHeight, width, height } = e.currentTarget;
    const crop = buildInitialCrop(naturalWidth, naturalHeight);
    const pixelCrop = convertToPixelCrop(crop, width, height);
    this.setState({ crop, pixelCrop });
    this.props.onCropChange(this.toSourcePixelCrop(pixelCrop));
  };

  toSourcePixelCrop = pxCrop => {
    const img = this.imgRef.current;
    if (!img || !pxCrop) return null;
    const scaleX = img.naturalWidth / img.width;
    const scaleY = img.naturalHeight / img.height;
    return {
      x: Math.round(pxCrop.x * scaleX),
      y: Math.round(pxCrop.y * scaleY),
      width: Math.round(pxCrop.width * scaleX),
      height: Math.round(pxCrop.height * scaleY),
    };
  };

  onChange = (pixelCrop, percentCrop) => {
    this.setState({ crop: percentCrop, pixelCrop });
  };

  onComplete = pixelCrop => {
    this.setState({ pixelCrop });
    this.props.onCropChange(this.toSourcePixelCrop(pixelCrop));
  };

  reset = () => {
    const img = this.imgRef.current;
    if (!img) return;
    const crop = buildInitialCrop(img.naturalWidth, img.naturalHeight);
    const pixelCrop = convertToPixelCrop(crop, img.width, img.height);
    this.setState({ crop, pixelCrop });
    this.props.onCropChange(this.toSourcePixelCrop(pixelCrop));
  };

  render() {
    const { classes, src } = this.props;
    const { crop } = this.state;
    return (
      <ReactCrop
        crop={crop}
        aspect={ASPECT}
        minWidth={MIN_DIMENSION}
        minHeight={MIN_DIMENSION}
        keepSelection
        ruleOfThirds
        onChange={this.onChange}
        onComplete={this.onComplete}
      >
        <img
          ref={this.imgRef}
          src={src}
          alt=""
          className={classes.cropImg}
          onLoad={this.onImageLoad}
        />
      </ReactCrop>
    );
  }
}
